<template>
  <div>
    <Head title="Dashboard" />

    <div class="dashboard">
      <div class="main">
      <textblock :textblocks="textblocks" :auth="auth" :textid="4"></textblock>
    </div>



    <div class="weather">
      <a class="weatherwidget-io" href="https://forecast7.com/de/47d508d72/winterthur/" data-label_1="WINTERTHUR" data-label_2="Wetter" data-font="Open Sans" data-days="3" data-theme="pure" >WINTERTHUR Wetter</a>
    </div>

      <div class="event-teaser">
        <label><span>Nächste Events</span>
         <Link  href="/events"><img src="/img/icons/plus.svg" /></Link>
         </label>
        <ul class="event-block">
          <li v-for="(event,index) in lastevents" :key="index" >
            <div class="date">
              <span>{{ event.month_short }}</span>
              <span>{{ event.day_of_month }}</span>
              <span>{{ event.day }}</span>
            </div>
            <div class="info">
                <h4>{{ event.title }}</h4>
                <div class="time"> {{ event.time }} Uhr</div>
                <div class="location">{{ event.location.name }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="file-teaser">
        <label>Reglemente</label>
        <ul class="">
          <li v-for="(file,index) in files[2]">
            <a v-bind:class="['is-'+file.extension,'file-row']" :href="file.path">
              <div><span>{{ file.name }}</span><div>{{ file.createt_at }}</div></div>
            </a>
          </li>

        </ul>
      </div>

      <div class="today"><span><label>{{ weekday }}</label><i>{{ date }}</i></span></div>

      <div class="calendar-teaser">
         <vue-cal
          ref="vuecal"
          locale="de"
           hide-view-selector
          :disable-views="['years', 'year', 'year','week','day']"
          active-view="month"
          :time-from="7 * 60" :time-to="22 * 60"
          :events="events"
          :on-event-click="onEventClick">
        ></vue-cal>
      </div>


    </div>


  </div>
</template>

<script>
  import { Head,Link } from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import Textblock from '@/Shared/Textblock'


  import VueCal from 'vue-cal'
  import 'vue-cal/dist/i18n/de.js'
  import 'vue-cal/dist/vuecal.css'

  import $ from "jquery";

  !(function (d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (!d.getElementById(id)) {
          js = d.createElement(s);
          js.id = id;
          js.src = "https://weatherwidget.io/js/widget.min.js";
          fjs.parentNode.insertBefore(js, fjs);
      }
  })(document, "script", "weatherwidget-io-js");



  export default {
    components: {
      Head,
      Link,
      VueCal,
      Textblock,
      $
    },
    layout: Layout,
    props: {
      events: Object,
      locations: Object,
      textblocks: Object,
      auth: Object,
      files: Object
    },
    data: function () {
      return {
        date: null,
        weekday: null,
      }
    },
    computed:{
      lastevents() {
        return  this.events.slice(0, 3);
      }
    },
    mounted() {
      this.$parent.bgimage = "/img/tower.jpg";
      let app = this;
      let weekdays = ["Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","Sonntag"];
      const today = new Date();
      const day = today.getDay();
      app.date = today.getDate();
      app.weekday = weekdays[day];

      setTimeout(function() {
          const { texts } = app.$refs.vuecal
          texts.weekDays = texts.weekDays.map(text => text.substring(0, 2));
          app.textblock = app.textblocks.find(x => x.id === 4);

      }, 5);



    },

    methods:{
       formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
      },

    }
  }
</script>
